import { Component, OnInit, ViewChild } from '@angular/core';
import { SetPinLimitRequest, AccountStatus, SetPinType, SetPinLimitStep } from 'src/app/models/account';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-set-pin-limit',
  templateUrl: './set-pin-limit.component.html',
  styleUrls: ['./set-pin-limit.component.css']
})
export class SetPinLimitComponent implements OnInit {
  accountStatus: AccountStatus;
  currentStep: SetPinLimitStep;

  limit: number;
  new_pin: string;
  cnf_pin: string;

  failMessage: string;
  isLoading: boolean = false;

  constructor(private router: Router,
    private authService: AuthenticationService) { }

  get getStep() { return SetPinLimitStep; }
  get getPinStep() { return SetPinType; }

  ngOnInit() {
    this.accountStatus = this.authService.getAccountStatusData();
    if (!this.accountStatus.already_set_limit || !this.accountStatus.already_set_pin) {
      this.currentStep = SetPinLimitStep.SetLimit;
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  setLimit(limit: number) {
    this.limit = limit;
    this.currentStep = SetPinLimitStep.SetNewPin;
  }

  setNewPin(pin: string) {
    this.new_pin = pin;
    this.currentStep = SetPinLimitStep.SetConfirmPin;
  }

  setCnfPin(pin: string) {
    this.cnf_pin = pin;
    if (this.new_pin != this.cnf_pin) {
      this.failMessage = 'Pin Konfirmasi tidak sesuai dengan Pin Baru';
      $('#fail').modal('show');
      this.currentStep = SetPinLimitStep.SetNewPin;
    } else {
      let data = new SetPinLimitRequest();
      data.limit = this.limit;
      data.pin = this.new_pin;
      this.isLoading = true;
      this.authService.setPinLimit(data,
        resp => {
          this.isLoading = false;
          if (resp.alert.code == 200) {
            $('#success').modal('show');
            setTimeout(() => {
              $('#success').modal('hide');
              this.router.navigate(['/dashboard']);
            }, 2000);
          } else {
            this.currentStep = SetPinLimitStep.SetLimit;
            this.failMessage = resp.alert.message;
            $('#fail').modal('show');
          }
        },
        err => {
          this.currentStep = SetPinLimitStep.SetLimit;
          this.failMessage = err;
          $('#fail').modal('show');
        });
    }
  }
}
